<template>
  <div class="organization-player-container">
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="season">
        <template slot="header" slot-scope="scope">
          <div>注册赛季</div>
          <el-input
            v-model="search.season"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="organizationName">
        <template slot="header" slot-scope="scope">
          <div>会员单位名称</div>
          <el-input
            v-model="search.organizationName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="playerName">
        <template slot="header" slot-scope="scope">
          <div>运动员名称</div>
          <el-input
            v-model="search.playerName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"/>
    </div>
  </div>
</template>

<script>
import { getOrganizationPlayerRegList, getOrganizationPlayerRegListPagination } from '@/api/club'
import { showMessage } from '@/utils'

const defaultForm = {
  leagueId: '',
  matchId: '',
  season: ''
}

export default {
  name: 'organizationPlayerRegList',
  data() {
    return {
      search: {},
      list: [],
      seasonList: [],
      leagueList: [],
      matchList: [],
      dialogForm: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
    }
  },
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getOrganizationPlayerRegList(this.listQuery).then(response => {
        const data = response
        this.list = data
        this.listLoading = false
      })
      getOrganizationPlayerRegListPagination(this.listQuery).then(response => {
        const data = response[0]
        this.currentPage = data.pageNum
        this.totalCount = data.count
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.organization-player-container {
  margin: 30px 15px;
  .el-table {
    th {
      div {
        line-height: 20px;
      }
      .el-select {
        padding-left: 0;
        padding-right: 0;
        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
